import { render, staticRenderFns } from "./FrontendLayout.vue?vue&type=template&id=78aa4735"
import script from "./FrontendLayout.vue?vue&type=script&lang=js"
export * from "./FrontendLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports